import script from "./MainInfoInstantLink.vue?vue&type=script&setup=true&lang=js"
export * from "./MainInfoInstantLink.vue?vue&type=script&setup=true&lang=js"

import "./MainInfoInstantLink.vue?vue&type=style&index=0&id=bfa8a010&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bfa8a010"]])

export default __exports__